import React from 'react';
import { Image, StyleSheet, Text, View } from './components/base_components';

import MenuButton from './components/buttons/menu_button';
import WideButton from './components/buttons/wide_button';

import UserStore from './stores/user_store';
import UserCurrencyStore from './stores/user_currency_store';
import util from './tools/util';

const styles = StyleSheet.create({
  dankCoinScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '1.4em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
  balanceWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  balanceLabel: {
    color: 'white',
    fontSize: '1.4em',
  },
  balanceLine: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '3em',
    height: '3em',
  },
  coinText: {
    marginLeft: '0.4em',
    marginTop: '0.6em',
    color: 'white',
    fontSize: '2.5em',
  },
});

type Props = {};
type State = {
  dank_coin_balance: number;
};

const COIN_IMG = require('./assets/img/dank_coin.gif');

export default class DankCoinScreen extends React.PureComponent<Props, State> {
  state = {
    dank_coin_balance: UserCurrencyStore.getBalance('dank_coin') || 0,
  };
  componentDidMount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
    UserCurrencyStore.fetchCurrency('dank_coin');
    this._onCurrencyUpdate();
  }
  componentWillUnmount() {
    UserCurrencyStore.removeChangeListener(this._onCurrencyUpdate);
  }
  _onCurrencyUpdate = () => {
    const dank_coin_balance = UserCurrencyStore.getBalance('dank_coin') || 0;
    this.setState({ dank_coin_balance });
  };

  _onLoginPress = () => this.props.history.push('/login');
  render() {
    const { dank_coin_balance } = this.state;
    let balance = null;
    let action = null;
    if (UserStore.isLoggedIn()) {
      balance = (
        <View style={styles.balanceWrapper}>
          <Text style={styles.balanceLabel}>Your Balance:</Text>
          <View style={styles.balanceLine}>
            <Image style={styles.icon} resizeMode='contain' source={COIN_IMG} />
            <Text style={styles.coinText}>
              {util.doubleToString(dank_coin_balance)}
            </Text>
          </View>
        </View>
      );
    } else {
      action = (
        <WideButton
          style={styles.button}
          text='Login'
          onPress={this._onLoginPress}
        />
      );
    }

    return (
      <View style={styles.dankCoinScreen}>
        {balance}
        <Text style={styles.text}>
          Dank Coin is the best way to get Dank stuff.
        </Text>
        <Text style={styles.text}>
          Collect Dank Coins by playing games, placing on leaderboards, and
          performing other actions in Dank Games!
        </Text>
        <MenuButton />
        {action}
      </View>
    );
  }
}
